// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
import  jQuery  from "jquery"

import './app'
let $ = window.$ = window.jQuery = jQuery

import "trix"
import "@rails/actiontext"


